<template>
  <base-card>
    <div class="not-found">
      <p class="not-found__text">
        Sorry! <br />
        Page Not Found
      </p>
      <img src="../assets/9.svg" alt="404" class="not-found__img" />
    </div>
  </base-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bg {
  margin: 0;
  padding: 20vh;
}
.not-found {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &__img {
    widows: 500px;
    height: 500px;
  }
  &__text {
    color: var(--primary-color);
    font-family: "Anton", sans-serif;
    text-align: center;
    font-size: 30px;
  }
}
</style>
